export default {
  isOpened: false,
  user: null
}



// WEBPACK FOOTER //
// ./src/domain/chat/store/state.js